import React from 'react'

function Blur() {
  return (
    <div className='blur'></div>
  )
}

export default Blur